import React from 'react';

import {Box, Stack, Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {useAccountInformation} from 'presentation/pages/private/hooks';
import {CHANNELS_CONTACTS} from 'presentation/pages/private/help/constants/channelsContacts';
import {ChannelAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelAccordion';
import {ChannelPhone} from 'presentation/pages/private/help/components/ContactChannels/components/ChannelPhone';
import {FinancialSupportAccordion} from 'presentation/pages/private/help/components/ContactChannels/components/FinancialSupportAccordion';
import {ContactChannelsBrandProps} from 'presentation/pages/private/help/components/ContactChannels/types';
import {HelpPageTaggingEnum} from 'main/analytics/gaTagsEnum';

const {title, healthExamsAppointments, SAC, centralServices, financialSupport} =
	translations['pt-br'].privateFlow.help.channels.ccg;

export function CCGContactChannels({
	expandedState,
	handleAccordionToggle,
}: ContactChannelsBrandProps) {
	const {isValid} = useContractStatus();
	const {isResponsibleWithoutBenefits} = useAccountInformation();
	return (
		<Stack gap={1}>
			<Typography variant="subheader">{title}</Typography>

			<Box>
				{isValid && !isResponsibleWithoutBenefits ? (
					<ChannelAccordion
						dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_MARCACAO_AJUDA}
						title={healthExamsAppointments.title}
						handleAccordionToggle={handleAccordionToggle}
						expandedState={expandedState}>
						<AlertInfo.Root sx={{mb: 1}}>
							{healthExamsAppointments.alert}
						</AlertInfo.Root>

						<ChannelPhone
							value={CHANNELS_CONTACTS.CCG.APPOINTMENTS_EXAMS.phone1}
							mask={CopySectionMaskEnum.PHONE}
						/>
					</ChannelAccordion>
				) : null}
				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_CENTRAL_SERVICOS_AJUDA}
					title={centralServices.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<ChannelPhone value={CHANNELS_CONTACTS.CCG.CENTRAL_SERVICE.phone1} />
				</ChannelAccordion>
				<ChannelAccordion
					dataTagId={HelpPageTaggingEnum.CLICK_EXPANDIR_TELEFONE_SAC_AJUDA}
					title={SAC.title}
					handleAccordionToggle={handleAccordionToggle}
					expandedState={expandedState}>
					<AlertInfo.Root sx={{mb: 1}}>{SAC.alert}</AlertInfo.Root>
					<ChannelPhone value={CHANNELS_CONTACTS.CCG.SAC.phone1} />
				</ChannelAccordion>
				<FinancialSupportAccordion
					title={financialSupport.title}
					expandedState={expandedState}
					handleAccordionToggle={handleAccordionToggle}
				/>
			</Box>
		</Stack>
	);
}
